import { resolvePersonalizations } from './personalizationData';

const selectors = {
	egeContainer: '.Hero',
	navCaw: '.NavigationCAW',
	egeText: '.EliteGuestCard-text',
	egeCTAs: '.EliteGuestCard-ctas',
	egePhone: '.EliteGuestCard-ctas-phone',
	egeEmail: '.EliteGuestCard-ctas-email',
	ppcHero: '.PPCHero',
	ppcCaw: '.PPCHero .InlineCaw',
};

export default function initEliteGuestCard() {
	resolvePersonalizations('eliteGuestQueryParam', personalizations => {
		if (personalizations.eliteGuestQueryParam) {
			$.get(
				'/alt/apps/fshr/design3/elite-guest-card/' + $('html').attr('lang'),
				{},
				(data, status) => {
					if (status === 'success' && data) {
						const $egeContainer = $(selectors.egeContainer);
						const $navCaw = $(selectors.navCaw);
						$egeContainer.after(data);
						$egeContainer.parent().addClass('hasEliteGuestComponent');

						const html = `<article class="caw-standalone__wrapper caw-comp__wrapper">
						<section class="App-wrapper"><div class="App-wrapper__row">
						<div class="container">
						<div class="row App-wrapper__anchor">
						<div class="col-lg-12 App-wrapper_mainCol">
						<div class="cawComponent horizontal hasDestinationPicker hasEliteGuestComponent">
						<div class="cawFieldsContainer">${data}</div>
						</div></div></div></div></div></section>
						</article>`;
						if ($navCaw.length) {
							$navCaw.html(html);

							$navCaw
								.find('.App-wrapper_mainCol')
								.append('<button class=" hideButton ty-c3">hide</button>');
							$navCaw.find('.hideButton').click(function (e) {
								e.preventDefault();
								let theEvent;
								if (typeof Event === 'function') {
									theEvent = new Event('cawComponentClose');
								} else {
									theEvent = document.createEvent('Event');
									theEvent.initEvent('cawComponentClose', true, true);
								}
								window.dispatchEvent(theEvent);
							});

							//dispatch event indicating the popup has loaded
							let theEvent;
							if (typeof Event === 'function') {
								theEvent = new Event('cawComponentLoaded');
							} else {
								//IE support
								theEvent = document.createEvent('Event');
								theEvent.initEvent('cawComponentLoaded', true, true);
							}
							window.dispatchEvent(theEvent);

							//if an inline guest card delete the sticky footer and header ctas
							if ($egeContainer.length) {
								const smallCTAS = $('.Navigation-CAW-cta.CTA--small');
								smallCTAS.replaceWith('<div class="Navigation-emptyCAW"></div>');
								$('.Navigation-sticky-footer').remove();
								$('.Navigation-sticky-footer-gradient').remove();
							}
						} else {
							$egeContainer.addClass('noCAW');
						}
						const $ppcHero = $(selectors.ppcHero);
						$ppcHero.addClass('hasEliteGuestComponent');
						const $ppcCaw = $(selectors.ppcCaw);
						if ($navCaw.length) {
							$ppcCaw.html(html);
						}
					}
				}
			);
		}
	});
}
